import {
  LIST_PATIENT_REQUEST,
  LIST_PATIENT_SUCCESS,
  LIST_PATIENT_FAIL,
  LIST_PATIENT_SUMMARY_REQUEST,
  LIST_PATIENT_SUMMARY_SUCCESS,
  LIST_PATIENT_SUMMARY_FAIL,
  LIST_PATIENT_RELATION_SUMMARY_REQUEST,
  LIST_PATIENT_RELATION_SUMMARY_SUCCESS,
  LIST_PATIENT_RELATION_SUMMARY_FAIL,
  HISTORY_LOG_PATIENT_REQUEST,
  HISTORY_LOG_PATIENT_SUCCESS,
  HISTORY_LOG_PATIENT_FAIL,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAIL,
  DETAIL_PATIENT_REQUEST,
  DETAIL_PATIENT_SUCCESS,
  DETAIL_PATIENT_FAIL,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAIL,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  SYNC_SATUSEHAT_PATIENT_REQUEST,
  SYNC_SATUSEHAT_PATIENT_SUCCESS,
  SYNC_SATUSEHAT_PATIENT_FAIL
} from '../../constants/patient'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingHistory: false,
  history: [],
  patients: [],
  patientSummary: [],
  patientRelationSummary: [],
  loadingDelete: false,
  loadingCreate: false,
  loadingSync: false,
  patient: {},
  error: null,
  pageable: {}
}

const listPatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PATIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        patients: action.payload,
        pageable: action.pageable
      }
    case LIST_PATIENT_FAIL:
      return { ...state, loading: false, error: action.payload, patients: [] }
    case LIST_PATIENT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_PATIENT_SUMMARY_SUCCESS:
      return { ...state, loading: false, patientSummary: action.payload }
    case LIST_PATIENT_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_PATIENT_RELATION_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_PATIENT_RELATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        patientRelationSummary: action.payload
      }
    case LIST_PATIENT_RELATION_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case HISTORY_LOG_PATIENT_REQUEST:
      return { ...state, loadingHistory: true }
    case HISTORY_LOG_PATIENT_SUCCESS:
      return { ...state, loadingHistory: false, history: action.payload }
    case HISTORY_LOG_PATIENT_FAIL:
      return { ...state, loadingHistory: false, error: action.payload }
    case CREATE_PATIENT_REQUEST:
      return { ...state, loading: true }
    case CREATE_PATIENT_SUCCESS:
      return { ...state, loading: false }
    case CREATE_PATIENT_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_PATIENT_REQUEST:
      return { ...state, loadingDetail: true, patient: {} }
    case DETAIL_PATIENT_SUCCESS:
      return { ...state, loadingDetail: false, patient: action.payload }
    case DETAIL_PATIENT_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_PATIENT_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_PATIENT_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_PATIENT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_PATIENT_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_PATIENT_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_PATIENT_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case SYNC_SATUSEHAT_PATIENT_REQUEST:
      return { ...state, loadingSync: true }
    case SYNC_SATUSEHAT_PATIENT_SUCCESS:
      return { ...state, loadingSync: false }
    case SYNC_SATUSEHAT_PATIENT_FAIL:
      return { ...state, loadingSync: false, error: action.payload }
    default:
      return state
  }
}

export default listPatientReducer
